
(() => {
  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));

  function setupScrollRail(root) {
    if (root.dataset.cassavaReady === 'true') return;
    const viewport = root.querySelector('[data-cassava-viewport]');
    if (!viewport) return;
    root.dataset.cassavaReady = 'true';

    const prev = root.querySelector('[data-cassava-prev]');
    const next = root.querySelector('[data-cassava-next]');
    const dots = qsa(root, '[data-cassava-dot]');
    const cards = qsa(viewport, '[data-cassava-slide]');

    const amount = () => Math.max(viewport.clientWidth * 0.82, 260);
    prev?.addEventListener('click', () => viewport.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => viewport.scrollBy({ left: amount(), behavior: 'smooth' }));
    dots.forEach((dot, index) => dot.addEventListener('click', () => cards[index]?.scrollIntoView({ behavior:'smooth', inline:'start', block:'nearest' })));

    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
        if (prev) prev.disabled = viewport.scrollLeft <= 2;
        if (next) next.disabled = viewport.scrollLeft >= max;
        if (dots.length && cards.length) {
          const left = viewport.getBoundingClientRect().left;
          let closest = 0;
          let distance = Infinity;
          cards.forEach((card, i) => {
            const d = Math.abs(card.getBoundingClientRect().left - left);
            if (d < distance) { distance = d; closest = i; }
          });
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === closest));
        }
      });
    };
    viewport.addEventListener('scroll', update, { passive:true });
    window.addEventListener('resize', update, { passive:true });
    update();

    const autoplay = Number(root.dataset.autoplaySeconds || 0);
    if (autoplay > 0 && cards.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer;
      const start = () => {
        stop();
        timer = window.setInterval(() => {
          const max = viewport.scrollWidth - viewport.clientWidth - 4;
          if (viewport.scrollLeft >= max) viewport.scrollTo({left:0, behavior:'smooth'});
          else viewport.scrollBy({left:amount(), behavior:'smooth'});
        }, autoplay * 1000);
      };
      const stop = () => timer && window.clearInterval(timer);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      start();
    }
  }

  function setupTabs(root) {
    if (root.dataset.cassavaTabsReady === 'true') return;
    const buttons = qsa(root, '[role="tab"]');
    const panels = qsa(root, '[role="tabpanel"]');
    if (!buttons.length || !panels.length) return;
    root.dataset.cassavaTabsReady = 'true';
    buttons.forEach((button) => button.addEventListener('click', () => {
      const id = button.getAttribute('aria-controls');
      buttons.forEach(b => b.setAttribute('aria-selected', String(b === button)));
      panels.forEach(panel => panel.hidden = panel.id !== id);

      // On phones, keep the selected category fully visible instead of
      // leaving the last tab (e.g. Infusiones) clipped at the edge.
      if (window.matchMedia('(max-width: 749px)').matches) {
        button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }));
  }

  function init(scope = document) {
    qsa(scope, '[data-cassava-scroll-root]').forEach(setupScrollRail);
    qsa(scope, '[data-cassava-tabs]').forEach(setupTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


/* ============================================================
   V4.15 — Judge.me product reviews polish (performance-safe)
   No global MutationObserver: bounded retries only.
   ============================================================ */
(() => {
  const REVIEW_SECTION_SELECTOR = '[id*="judgeme_section_review_widget"]';
  const MAX_ATTEMPTS = 10;
  const RETRY_MS = 450;

  function parseReviewCount(section) {
    if (!section) return null;

    const widget = section.querySelector('.jdgm-rev-widg, .jdgm-widget');
    if (!widget) return null;

    const explicit =
      widget.querySelector('[data-number-of-reviews]') ||
      section.querySelector('[data-number-of-reviews]');

    if (explicit) {
      const value = Number(explicit.getAttribute('data-number-of-reviews'));
      if (Number.isFinite(value)) return value;
    }

    const actualReviews = section.querySelectorAll('.jdgm-rev');
    if (actualReviews.length > 0) return actualReviews.length;

    const text = (section.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    if (
      text.includes('be the first to write a review') ||
      text.includes('sé el primero en escribir una reseña') ||
      text.includes('se el primero en escribir una reseña') ||
      text.includes('based on 0 reviews') ||
      text.includes('0 reviews') ||
      text.includes('0 reseñas') ||
      text.includes('0 reseña')
    ) {
      return 0;
    }

    const summary = section.querySelector(
      '.jdgm-rev-widg__summary-text, .jdgm-rev-widg__summary-text-compact'
    );

    if (summary) {
      const match = (summary.textContent || '').match(/(\d+)/);
      if (match) return Number(match[1]);
    }

    return null;
  }

  function hideEmptyPreviewBadge() {
    document
      .querySelectorAll('.product__info-container .jdgm-prev-badge')
      .forEach((badge) => {
        const badgeText = (badge.textContent || '').toLowerCase();
        const rawCount = badge.getAttribute('data-number-of-reviews');
        const badgeCount = rawCount === null ? null : Number(rawCount);

        if (
          badgeCount === 0 ||
          badgeText.includes('no reviews') ||
          badgeText.includes('0 reseña')
        ) {
          badge.style.display = 'none';
        }
      });
  }

  function polishReviewSection(section) {
    if (!section) return false;

    const count = parseReviewCount(section);
    if (count === null) return false;

    if (count <= 0) {
      section.classList.remove('cassava-reviews-ready');
      section.classList.add('cassava-reviews-empty');

      if (section.getAttribute('aria-hidden') !== 'true') {
        section.setAttribute('aria-hidden', 'true');
      }

      hideEmptyPreviewBadge();
      return true;
    }

    section.classList.remove('cassava-reviews-empty');
    section.classList.add('cassava-reviews-ready');
    section.removeAttribute('aria-hidden');

    const title = section.querySelector('.jdgm-rev-widg__title');
    if (title && title.textContent.trim() !== 'Lo que dicen nuestros Rocksters') {
      title.textContent = 'Lo que dicen nuestros Rocksters';
    }

    const summary = section.querySelector('.jdgm-rev-widg__summary-text');
    const desiredSummary = `${count} ${count === 1 ? 'reseña real' : 'reseñas reales'}`;
    if (summary && summary.textContent.trim() !== desiredSummary) {
      summary.textContent = desiredSummary;
    }

    const writeLink = section.querySelector('.jdgm-write-rev-link');
    if (writeLink && writeLink.textContent.trim() !== 'Escribir una reseña') {
      writeLink.textContent = 'Escribir una reseña';
    }

    return true;
  }

  function findReviewSections(scope = document) {
    const sections = [];

    if (
      scope instanceof Element &&
      scope.matches?.(REVIEW_SECTION_SELECTOR)
    ) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections.push(...scope.querySelectorAll(REVIEW_SECTION_SELECTOR));
    }

    return [...new Set(sections)];
  }

  function initProductReviews(scope = document, attempt = 0) {
    const sections = findReviewSections(scope);

    if (!sections.length) {
      if (attempt < MAX_ATTEMPTS) {
        window.setTimeout(
          () => initProductReviews(document, attempt + 1),
          RETRY_MS
        );
      }
      return;
    }

    const allResolved = sections.every(polishReviewSection);

    if (!allResolved && attempt < MAX_ATTEMPTS) {
      window.setTimeout(
        () => initProductReviews(document, attempt + 1),
        RETRY_MS
      );
    }
  }

  function bootProductReviews() {
    initProductReviews(document, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootProductReviews, {
      once: true
    });
  } else {
    bootProductReviews();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductReviews(event.target, 0);
  });
})();





















